let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i9hMU")).then(() => parcelRequire('9V6G3'));